import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { withFormikField, getFormikError } from 'utils/formik';
import { Field, Flexer } from '@ontruck/orc';
import Select from 'react-select-v3';
import { injectIntl } from 'react-intl';
const StyledField = styled(Field)`
  //   width: 100%;
`;
const StyledSelect = styled(Select)`
  width: 10rem;
`;
const containerCodes = [
  { label: '20G0', value: '20G0' },
  { label: '20G1', value: '20G1' },
  { label: '20H0', value: '20H0' },
  { label: '20P1', value: '20P1' },
  { label: '20T3', value: '20T3' },
  { label: '20T4', value: '20T4' },
  { label: '20T5', value: '20T5' },
  { label: '20T6', value: '20T6' },
  { label: '20T7', value: '20T7' },
  { label: '20T8', value: '20T8' },
  { label: '20T0', value: '20T0' },
  { label: '20T1', value: '20T1' },
  { label: '20T2', value: '20T2' },
  { label: '22B0', value: '22B0' },
  { label: '22G0', value: '22G0' },
  { label: '22G1', value: '22G1' },
  { label: '22H0', value: '22H0' },
  { label: '22P3', value: '22P3' },
  { label: '22P8', value: '22P8' },
  { label: '22P9', value: '22P9' },
  { label: '22P1', value: '22P1' },
  { label: '22P7', value: '22P7' },
  { label: '22R9', value: '22R9' },
  { label: '22R7', value: '22R7' },
  { label: '22R1', value: '22R1' },
  { label: '22S1', value: '22S1' },
  { label: '22T3', value: '22T3' },
  { label: '22T4', value: '22T4' },
  { label: '22T5', value: '22T5' },
  { label: '22T6', value: '22T6' },
  { label: '22T7', value: '22T7' },
  { label: '22T8', value: '22T8' },
  { label: '22T0', value: '22T0' },
  { label: '22T1', value: '22T1' },
  { label: '22T2', value: '22T2' },
  { label: '22U6', value: '22U6' },
  { label: '22U1', value: '22U1' },
  { label: '22V0', value: '22V0' },
  { label: '22V2', value: '22V2' },
  { label: '22V3', value: '22V3' },
  { label: '25G0', value: '25G0' },
  { label: '26G0', value: '26G0' },
  { label: '26H0', value: '26H0' },
  { label: '28T8', value: '28T8' },
  { label: '28U1', value: '28U1' },
  { label: '28V0', value: '28V0' },
  { label: '29P0', value: '29P0' },
  { label: '2EG0', value: '2EG0' },
  { label: '42G0', value: '42G0' },
  { label: '42G1', value: '42G1' },
  { label: '42H0', value: '42H0' },
  { label: '42P3', value: '42P3' },
  { label: '42P8', value: '42P8' },
  { label: '42P9', value: '42P9' },
  { label: '42P1', value: '42P1' },
  { label: '42P6', value: '42P6' },
  { label: '42R9', value: '42R9' },
  { label: '42R3', value: '42R3' },
  { label: '42R1', value: '42R1' },
  { label: '42S1', value: '42S1' },
  { label: '42T5', value: '42T5' },
  { label: '42T6', value: '42T6' },
  { label: '42T8', value: '42T8' },
  { label: '42T2', value: '42T2' },
  { label: '42U6', value: '42U6' },
  { label: '42U1', value: '42U1' },
  { label: '45B3', value: '45B3' },
  { label: '45G0', value: '45G0' },
  { label: '45G1', value: '45G1' },
  { label: '45P3', value: '45P3' },
  { label: '45P8', value: '45P8' },
  { label: '45R9', value: '45R9' },
  { label: '45R1', value: '45R1' },
  { label: '45U1', value: '45U1' },
  { label: '45U6', value: '45U6' },
  { label: '46H0', value: '46H0' },
  { label: '48T8', value: '48T8' },
  { label: '49P0', value: '49P0' },
  { label: '4CG0', value: '4CG0' },
  { label: 'L0G1', value: 'L0G1' },
  { label: 'L2G1', value: 'L2G1' },
  { label: 'L5G1', value: 'L5G1' },
];

const TenantLoadSection = ({ field, form, shipments, intl, ...props }) => {
  const t = intl.messages.modules.shipper_order.form.load_section;
  const { name, value = {} } = field;
  const {
    container_iso_code,
    reference_number,
    total_weight,
    seal_number,
    container_plate_number,
  } = value;
  const { setFieldValue } = form;
  const [shipmentsLength, setShipmentsLength] = useState(0);
  useEffect(() => {
    if (
      shipmentsLength === shipments.length &&
      shipments[0]?.loads[0]?.load_type === 'SHIPPING_CONTAINER'
    )
      return;
    setShipmentsLength(shipments.length);
    setFieldValue(
      'shipments',
      (shipments || []).map((s, i) =>
        i === 0
          ? {
              ...s,
              loads: [{ ...s.loads[0], load_type: 'SHIPPING_CONTAINER' }],
            }
          : {
              ...s,
              loads: [{ ...s.loads[0], load_type: 'BULK' }],
            }
      )
    );
  }, [shipments, setFieldValue, shipmentsLength]);

  const loadWeight = useMemo(
    () =>
      shipments
        .map((s, i) => (i === 0 ? 0 : s.loads[0]?.total_weight || 0))
        .reduce((p, n) => p + n / 1, 0),
    [shipments]
  );

  const selected_container_iso = useMemo(
    () => containerCodes.find((code) => code.value === container_iso_code),
    [container_iso_code]
  );

  return (
    <Flexer.Parent justifyContent="space-between" mBottom="M">
      <Flexer.Child>
        <StyledSelect
          placeholder={t.container_iso_code}
          ignoreCase={true}
          matchPos="any"
          clearable={false}
          small
          name={[name, 'container_iso_code']}
          value={selected_container_iso}
          options={containerCodes}
          onChange={({ value }) => {
            setFieldValue(`${name}.container_iso_code`, value);
          }}
          width={360}
          invalid={!!getFormikError({ field: { name: `${name}.container_iso_code` }, form })}
        />
      </Flexer.Child>
      <Flexer.Child>
        <StyledField
          {...props}
          name={[name, 'reference_number']}
          label={t.reference}
          value={reference_number}
          error={false}
          onChange={(e, { value }) => {
            setFieldValue(`${name}.reference_number`, value);
          }}
        />
      </Flexer.Child>
      <Flexer.Child>
        <StyledField
          {...props}
          name={[name, 'total_weight']}
          label={t.container_weight}
          value={total_weight}
          error={false}
          onChange={(e, { value }) => {
            setFieldValue(`${name}.total_weight`, value);
          }}
          invalid={!!getFormikError({ field: { name: `${name}.total_weight` }, form })}
        />
      </Flexer.Child>
      <Flexer.Child>
        <StyledField
          {...props}
          label={t.load_weight}
          value={loadWeight}
          error={false}
          disabled
          invalid={
            !!getFormikError({ field: { name: `shipments[0].loads[0].total_weight` }, form })
          }
        />
      </Flexer.Child>
      <Flexer.Child>
        <StyledField
          {...props}
          name={[name, 'seal_number']}
          label={t.seal_number}
          value={seal_number}
          error={false}
          onChange={(e, { value }) => {
            setFieldValue(`${name}.seal_number`, value);
          }}
          invalid={!!getFormikError({ field: { name: `shipments[0].loads[0].seal_number` }, form })}
        />
      </Flexer.Child>
      <Flexer.Child>
        <StyledField
          {...props}
          name={[name, 'container_plate_number']}
          label={t.container_plate_number}
          value={container_plate_number}
          error={false}
          onChange={(e, { value }) => {
            setFieldValue(`${name}.container_plate_number`, value);
          }}
          invalid={
            !!getFormikError({
              field: { name: `shipments[0].loads[0].container_plate_number` },
              form,
            })
          }
        />
      </Flexer.Child>
    </Flexer.Parent>
  );
};

TenantLoadSection.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

export default withFormikField(injectIntl(TenantLoadSection));
